import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackHomeFeedLayoutElementCustomItemClick } from "@faire/web-api--source/events/homeFeed/click/layoutElementCustomItem";
import myBrandsUpdates from "@faire/web-api--source/routes/my-brands/updates";
import React from "react";
import styled from "styled-components";
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { EventOrigin } from "@faire/retailer/features/InsightsFeed/events";
import { InsightCard } from "@faire/retailer/features/InsightsFeed/InsightCard";
import { InsightCardContextProvider } from "@faire/retailer/features/InsightsFeed/InsightCardContext";
import { CarouselBase } from "../CarouselBase";
export var InsightsCarousel = function(props) {
    var CarouselBaseComponent = CarouselBase;
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, requestId = _React_useContext.requestId, onItemClick = _React_useContext.onItemClick, onVisible = _React_useContext.onVisible;
    var handleClick = function(token) {
        var _layoutElement_on_click_event_name;
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId, token);
    };
    var handleCtaTileClick = function() {
        var _layoutElement_on_click_event_name;
        trackHomeFeedLayoutElementCustomItemClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId, "see-all-tile");
    };
    var ctaTileData = {
        text: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "dKw82f",
            defaultMessage: [
                {
                    type: 0,
                    value: "Show all"
                }
            ]
        }),
        linkTo: myBrandsUpdates(),
        onClick: handleCtaTileClick
    };
    var renderItem = function(tile, index) {
        var _tile_insight_token;
        return /*#__PURE__*/ _jsx(BottomBorderDiv, {
            children: /*#__PURE__*/ _jsx(InsightCard, {
                asCarouselTile: true,
                data: tile
            })
        }, (_tile_insight_token = tile === null || tile === void 0 ? void 0 : tile.insight_token) !== null && _tile_insight_token !== void 0 ? _tile_insight_token : index);
    };
    var items = layoutElement.layout_element_data.map(function(data) {
        return data.insight_tile;
    }).filter(isNotUndefined);
    var onItemsVisible = function(items) {
        var itemTokens = items.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.insight_token;
        });
        if (layoutElement.on_click_event_name) {
            var _itemTokens_join;
            onVisible === null || onVisible === void 0 ? void 0 : onVisible(layoutElement.on_click_event_name, requestId, (_itemTokens_join = itemTokens === null || itemTokens === void 0 ? void 0 : itemTokens.join(" ")) !== null && _itemTokens_join !== void 0 ? _itemTokens_join : "");
        }
    };
    return /*#__PURE__*/ _jsx(InsightCardContextProvider, {
        origin: EventOrigin.HomeFeed,
        onCardClick: handleClick,
        children: /*#__PURE__*/ _jsx(CarouselBaseComponent, _object_spread_props(_object_spread({}, props), {
            renderItem: renderItem,
            items: items,
            itemsPerSlide: {
                mobileAndAbove: 1,
                tabletAndAbove: 2,
                desktopAndAbove: 3
            },
            itemGap: {
                mobileAndAbove: 8,
                tabletAndAbove: 16
            },
            ctaTileData: ctaTileData,
            peekNextPercent: {
                mobileAndAbove: 15,
                tabletAndAbove: 0
            },
            lateralPadding: 16,
            noWrap: true,
            onItemsVisible: onItemsVisible
        }))
    });
};
var BottomBorderDiv = styled.div.withConfig({
    componentId: "sc-ac8237c7-0"
})([
    "padding-bottom:1px;"
]);
